<div *ngIf="(isMobile$ | async) === false" class="flex items-center justify-between p-4 flex-shrink-0">
  <!-- Left side - Close button -->
  <ui-button icon="griddy-chevron-left" variant="quaternary" size="sm" (onClick)="close()"></ui-button>

  <!-- Center - Title -->
  <span class="font-semibold">Copilot</span>

  <!-- Right side - Empty placeholder for centering -->
  <div class="w-8 h-8"></div>
</div>

<!-- Header with Search and New Chat Button -->
<div class="flex items-center gap-2 p-4 border-b border-gray-200">
  <div class="flex-1 h-8">
    <sbnb-search-bar
      placeholderText="Search chats..."
      [debounceTimeMs]="200"
      size="mini"
      class="p-0 m-0 h-full"
      (searchChanged)="handleSearchChange($event)">
    </sbnb-search-bar>
  </div>
  <div class="h-8">
    <ui-button label="New chat" variant="primary" size="sm" (onClick)="handleNewChat()"> </ui-button>
  </div>
</div>

<!-- Conversations List -->
<div class="flex-1 overflow-y-auto min-h-0" data-testid="copilot-drawer-conversations">
  <div class="p-4 space-y-2">
    <sbnb-chat-list-item
      *ngFor="let conversation of filteredConversations$ | async"
      [conversation]="conversation"
      [currentConversationUuid]="currentConversationUuid"
      (conversationClicked)="handleConversationClick($event)"
      (deleteClicked)="handleDeleteClick($event.event, $event.conversation)">
    </sbnb-chat-list-item>

    <!-- No results message -->
    <div
      *ngIf="(filteredConversations$ | async)?.length === 0 && searchQuery$.value.length >= 3"
      class="text-center py-8 text-gray-500">
      <p class="text-sm">No conversations found matching "{{ searchQuery$.value }}"</p>
    </div>
  </div>
</div>
